import React from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import { styles } from './CreativeHeader.styles'
import BrushIcon from '../../Assets/Images/icons/newIcons/brushIcon'
import Upload from 'Assets/Images/icons/upload'
import { Figma } from 'Assets/Images/logos'
import { useFeatureFlags } from '../../Context/FeatureFlagsContext'

const useStyles = makeStyles(() => styles)

const CreativeHeader = ({
  onCreateDesign = () => {},
  onCreateDesignInFigma = () => {},
  type,
}) => {
  const classes = useStyles()
  const history = useHistory()
  const { isFigmaEnabled } = useFeatureFlags()

  return (
    <header className={classes.header}>
      <div className={classes.iconRow}>
        <BrushIcon size={24} color="#f43f5e" />
        <span className={classes.iconText}>Creative</span>
      </div>
      <h1 className={classes.title}>Creative</h1>
      <div className={classes.contentRow}>
        <p className={classes.subtitle}>Create or select your {type}.</p>
        <nav className={classes.navigation}>
          <button
            onClick={() => {
              history.push('/dashboard/design-management/upload')
            }}
            className={`${classes.navButton} ${classes.uploadButton}`}
          >
            <div className={classes.uploadButtonText}>
              <Upload isNew={true} />
              Upload {type?.charAt(0).toUpperCase() + type?.slice(1)}
            </div>
          </button>
          {isFigmaEnabled && (
            <button
              className={`${classes.navButton} ${classes.figmaButton}`}
              onClick={onCreateDesignInFigma}
            >
              <span className={classes.figmaIcon}>
                <Figma size={24} />
              </span>
              Create in Figma
            </button>
          )}
          <button
            className={`${classes.navButton} ${classes.designToolButton}`}
            onClick={onCreateDesign}
          >
            <BrushIcon color="#ffffff" />
            Create with Design Tool
          </button>
        </nav>
      </div>
    </header>
  )
}

export default CreativeHeader
